"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var BaseDealerLayout_1 = require("./layouts/baseDealerLayout/BaseDealerLayout");
var DealerSelector_1 = require("./dealerSelector/DealerSelector");
var DealerPageTitle_1 = require("./dealerPageTitle/DealerPageTitle");
var DealerPageInfo_1 = require("./dealerPageInfo/DealerPageInfo");
var Dealer = function () {
    return (<BaseDealerLayout_1.default pageInfoSlot={<DealerPageInfo_1.default />} pageTitleSlot={<DealerPageTitle_1.default />} mainContentSlot={<DealerSelector_1.default />}/>);
};
exports.default = Dealer;
